import { fetchUsersGroups, selectUsersGroups, toUnifiedGroupTreeNode } from "@/entities/groups"
import { selectCommunityInfo, updateDefaultGroupId } from "@/entities/community"
import { GroupTree } from "@/features/groups"
import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { setDefaultGroup } from "@/shared/api/community"
import notify from "@/shared/lib/notify"
import { getErrorMessage } from "@/shared/consts/error-codes"
import { useMemo } from "react"

export const GroupsGrid = () => {
    const groups = useAppSelector(selectUsersGroups)
    const communityInfo = useAppSelector(selectCommunityInfo)
    const dispatch = useAppDispatch()
    const onUpdate = () => {
        dispatch(fetchUsersGroups())
    }

    const onSetDefaultGroup = async (groupId: string) => {
        try {
            await setDefaultGroup(groupId)
            dispatch(updateDefaultGroupId(groupId))
            notify.success('Системная группа обновлена')
        } catch (error: any) {
            notify.error(getErrorMessage(error?.response?.data))
        }
    }

    const treeItems = useMemo(() => toUnifiedGroupTreeNode(groups), [groups])
    const roots = useMemo(() => treeItems.filter(i => i.data.parent === null), [treeItems])

    return (
        <div className="grid grid-cols-12 gap-4">
            {roots.map(root => (
                <div key={root.id} className="col-span-6 screen:col-span-4">
                    <GroupTree 
                        rootId={root.parent}
                        treeData={treeItems}
                        role={'users'}
                        onUpdate={onUpdate}
                        defaultGroupId={communityInfo.default_group_id}
                        onSetDefaultGroup={onSetDefaultGroup}
                    />
                </div>
            ))}
        </div>
    )
}
